const advantages = [
  {
    icon: 'ri-gamepad-line',
    title: '海量游戏库',
    description: 'galagame 拥有超过500款精品游戏，涵盖动作、角色扮演、策略、休闲等多种类型，持续更新最新热门大作。',
    accent: 'text-primary-500',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极致体验',
    description: 'galagame 采用先进的云游戏技术，低延迟高画质，无论在何种设备上都能享受流畅丝滑的游戏体验。',
    accent: 'text-accent-500',
  },
  {
    icon: 'ri-trophy-line',
    title: '丰厚奖励',
    description: '参与 galagame 每日任务、赛季活动和电竞赛事，赢取现金奖励、限定皮肤和实物周边等丰厚奖品。',
    accent: 'text-secondary-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: 'galagame 采用银行级加密技术和AI风险识别系统，全方位守护你的账号安全和游戏数据隐私。',
    accent: 'text-primary-500',
  },
  {
    icon: 'ri-team-line',
    title: '活跃社区',
    description: '加入 galagame 千万玩家社区，组队开黑、分享攻略、参与讨论，找到志同道合的游戏伙伴。',
    accent: 'text-accent-500',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专属客服',
    description: 'galagame 提供7x24小时专属客服支持，无论是技术问题还是游戏咨询，我们都随时为你服务。',
    accent: 'text-secondary-500',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            为什么选择 galagame
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大核心优势，打造无与伦比的游戏体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-6 border border-background-200/50 hover:border-background-300/60 transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-background-200 mb-4`}>
                <i className={`${item.icon} text-xl ${item.accent}`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-100 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}